import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class ImpactedDevicesChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "",
          data: [28, 24, 20, 14, 13],
        },
      ],
      options: {
        chart: {
          type: "area",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          categories: [
            "2WLL-20-21-PSY-0001",
            "2WLL-20-20-PSY-0001",
            "2KTB-03-06-PSY-0001",
            "2ORC-01-13-PSY-0001",
            "2FRE-64-02-PSY-0001",
          ],
          title: {
            text: "Node", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
          },
          title: {
            text: "Alarms", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
        },
        stroke: {
          curve: "straight",
          width: 3,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          area: {
            fillTo: "origin",
          },
        },
      },
    };
  }

  render() {
    return (
      <>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height={300}
        />
      </>
    );
  }
}
